import api from "../api.service"

export async function createStorageKey() {
    return api
        .post(`/storageKey`)
        .then((res) => res.data)
        .catch((err) => {
            throw api.getResponseError(err)
        })
}

export async function getStorageKey(keyId) {
    return api
        .get(`/storageKey/${keyId}`)
        .then((res) => res.data)
        .catch((err) => {
            if (!!err?.response) {
                throw err.response
            }
            throw api.getResponseError(err)
        })
}
